import React, { useEffect } from "react";
import clsx from "clsx";

import { useQuizContext } from "./QuizCollection";

export const Question = ({data}) => {

    //Global quiz functions
    const { quizFunctions } = useQuizContext();

    const question = data.question
    const image = data.image
    const filter = data.filter
    const facet = data?.facet ? data.facet : false
    const answers = data.answers
    const multiple_choice = data?.multiple_choice
    
    const [filterString, setFilterString] = React.useState('');

    //Check for preselected answers when quiz is progressed backwards
    let preselectedAnswers = quizFunctions?.currentAnswers.find((q) => q.question.includes(question)) ? quizFunctions?.currentAnswers.find((q) => q.question.includes(question))?.answers : []

    const [answersSelected, setanswerSelected] = React.useState(preselectedAnswers);

    let totalStepsArray = new Array(quizFunctions.totalSteps + 1).fill("");

    const handleClick = (e) => {
        if(!multiple_choice){
            document.querySelectorAll('input:checked').forEach((input) => {
                if(input != e.target){
                    input.checked = false
                    input.disabled = false;
                }
            })
            e.target.disabled = true;
            setanswerSelected([e.target.value]);
        } else {
            e.target.checked == true ? setanswerSelected([...answersSelected, e.target.value]) : setanswerSelected(answersSelected.filter(ans => ans !== e.target.value));
        }
    }

    // Functionality revisions
    const handleQuizProgress = () => {
        //Progress quiz onto next step
        quizFunctions.nextStep();

        //Save current answers & question to quiz state
        let backtrackArray = {
            "question": question,
            "filter": filter,
            "facet": facet,
            "answers": (answersSelected)
        }

        if(!quizFunctions.currentAnswers.find((q) => q.question.includes(question))){
            quizFunctions.currentAnswers.push(backtrackArray);
        } else {
            if(answersSelected.length) {
                quizFunctions.currentAnswers.find((q) => q.question.includes(question)).answers = answersSelected
            }
        }
    }

    //Enable or Disable progress button
    const handleCanProgress = () => {
        if(answersSelected.length == 0){
            return true
        }

        if(answersSelected.length == 0 && preselectedAnswers.length != 0){
            return false
        }

        if(!answersSelected.length){
            return true
        }
    }

    return (
        <div
            className={clsx('question-step', 
                { 'fadein' : quizFunctions.fadeEffect == 'fadein'},
            )}
        >
            <div className="question-content-wrapper">
                <div className="indicator-wrapper">
                    <p className="indicator-question-label">Question {quizFunctions.currentStep + 1} of {quizFunctions.totalSteps + 1}</p>
                    <div className="indicator-bars-wrapper">
                        <progress id="quizProgress" max={(quizFunctions.totalSteps + 1) * 10} value={(quizFunctions.currentStep + 1) * 10} ></progress>
                    </div>
                </div>

                <div className="question">
                    <h2>{question}</h2>
                    {multiple_choice ? (<p>Select all answers that apply.</p>) : (<p>Select one answer.</p>)}
                </div>
                <div className="answers-wrapper">
                <p className="activity-label">{filter}</p>
                    <div className="answers">
                        {answers.map((ans, index) => {
                            return (
                                // { 'locked' : (!multiple_choice && answersSelected.length != 0 && !answersSelected.includes(ans.value)) }
                                <div className={clsx('answer')} key={index}>
                                    <input 
                                        id={`${filter}-${index}`}
                                        type="checkbox"
                                        className="visually-hidden"
                                        name={filter + '[]'} 
                                        value={ans.value}
                                        defaultChecked={preselectedAnswers?.includes(ans.value) ? true : false}
                                        onChange={handleClick}
                                    />
                                    <label htmlFor={`${filter}-${index}`}>{ans.answer}</label>
                                </div>
                            )
                        })}
                    </div>
                <div className="action-buttons-wrapper">
                    {quizFunctions.currentStep != 0 &&(<button className="previous" onClick={quizFunctions.prevousStep}>Previous</button>)}
                    <button 
                        className='button button--contained'
                        disabled={handleCanProgress()}
                        onClick={handleQuizProgress}
                    >Continue</button>
                </div>
                </div>

            </div>

            <div className="question-image">
                <div className="aspect-ratio-box">
                    <div className={"aspect-content"}>
                    <img className={"media"} src={image}></img>
                    </div>
                </div>
            </div>

        </div>
    )
}